// src/components/User/Footer/Footer.js

import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios'; 
import "./Footer.css";

function Footer() {
  const navigate = useNavigate(); 
  const [phone, setPhone] = useState('+91-XXXXXXXXXX'); // Default placeholder
  const MAPS_URL = "https://maps.app.goo.gl/gk69jC22ckPV6aTFA"; // Placeholder Maps URL
  const DEFAULT_EMAIL = "dietacmchapter@diet.edu.in";
  
  // Logic to fetch the phone number dynamically
  useEffect(() => {
    axios.get('/contactinfo') 
      .then(res => {
        if (res.data?.phone) {
          setPhone(res.data.phone);
        }
      })
      .catch(err => {
        console.error('Failed to fetch phone:', err);
        setPhone('+91-XXXXXXXXXX');
      });
  }, []);

  return (
    <footer className="footer">
      <div className="footer-socials">
        <a
          href="https://www.linkedin.com/in/diet-acm-chapter-846b55328/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin"></i>
        </a>
        <a
          href="https://www.instagram.com/diet_acm"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=100090846908967"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-facebook"></i>
        </a>
      </div>

      <div className="footer-contact">
        <div className="contact-item">
          {/* WRAPPING ADDRESS IN LINK TAG (Icon and Text Link to Maps) */}
          <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="contact-link">
            <i className="fas fa-map-marker-alt"></i>
          </a>
          <div>
            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="contact-link">
              <h4>Find Us</h4>
              <p>
                Dadi Institute of Engineering and Technology
                <br />
                Anakapalle, Andhra Pradesh
              </p>
            </a>
          </div>
        </div>

        <div className="contact-item">
          <i className="fas fa-phone"></i>
          <div>
            <h4>Call Us</h4>
            <p>{phone}</p> {/* Dynamic phone number is rendered here */}
          </div>
        </div>

        <div className="contact-item">
          <a href={`mailto:${DEFAULT_EMAIL}`} className="contact-link">
            <i className="fas fa-envelope"></i>
          </a>
          <div>
            <a href={`mailto:${DEFAULT_EMAIL}`} className="contact-link">
              <h4>Mail Us</h4>
              <p>{DEFAULT_EMAIL}</p>
            </a>
          </div>
        </div>
      </div>

      <hr className="footer-divider" />
      <p className="footer-bottom">
        © {new Date().getFullYear()} DIET ACM Student Chapter. All rights reserved.
      </p>

      {/* DEVELOPER BUTTON */}
      <button className="developer-button" onClick={() => navigate('/developer')}>
        {'{ }'}
      </button>
    </footer>
  );
}

export default Footer;